import { TokenHistoryRecordKind } from '@do/models';

import type { IconNames } from '@shared/ui/icon';

// export declare enum TokenHistoryRecordKind {
//   Transfer = 'transfer',
//   Mint = 'mint',
//   Buy = 'buy',
//   AuctionCreated = 'auction_created',
//   AuctionBidPlaced = 'auction_bid_placed',
//   AuctionSold = 'auction_sold',
//   MarketPlaced = 'market_placed',
//   MarketRealized = 'market_realized',
//   MarketCancelled = 'market_cancelled',
// }

export const historyTypes = {
  transfer: TokenHistoryRecordKind.Transfer,
  buy: TokenHistoryRecordKind.Buy,
  mint: TokenHistoryRecordKind.Mint,
  auctionCreated: TokenHistoryRecordKind.AuctionCreated,
  auctionBidPlaced: TokenHistoryRecordKind.AuctionBidPlaced,
  auctionSold: TokenHistoryRecordKind.AuctionSold,
  marketPlaced: TokenHistoryRecordKind.MarketPlaced,
  marketRealized: TokenHistoryRecordKind.MarketRealized,
  marketCancelled: TokenHistoryRecordKind.MarketCancelled,
} as const;

export const historyIcons: { [key: string]: IconNames } = {
  [historyTypes.buy]: 'wallet',
  [historyTypes.transfer]: 'arrowsLeftRight',

  [historyTypes.auctionSold]: 'auctions',
  [historyTypes.auctionBidPlaced]: 'wallet',
};

export const historyLabels: { [key: string]: string } = {
  [historyTypes.buy]: 'Purchase made by',
  [historyTypes.transfer]: 'Transferred from',

  [historyTypes.auctionSold]: 'Auction ended. Wallet',
  [historyTypes.auctionBidPlaced]: 'Bid placed by',
  [historyTypes.mint]: 'Minted by',
  [historyTypes.auctionCreated]: 'Created by',
};

export const HISTORY_LIMIT = '10';
